import React from "react";

import {
  headerStyle,
  titleStyle,
  descriptionStyle,
  vagasLinkStyle,
  linkWrapperStyle,
  inlineLinkStye,
} from "./vaga-criada.css";
import { IlustracaoVagaCriada } from "./illustration/ilustracao-vaga-criada";
import { Space } from "./components/space";
import { IlustracaoPrancheta } from "./illustration/ilustracao-prancheta";
import { FeedbackCard } from "./components/feedback-card";
import { Text } from "@vagastec/ensemble-core";
import { FormattedMessage } from "react-intl";

export function VagaModeloCriada({ formState, setFormState }) {
  return (
    <div>
      <Space />
      <div className={headerStyle}>
        <IlustracaoVagaCriada />
        <Space />
        <h1 className={titleStyle}>
          {" "}
          <FormattedMessage
            id="vagaModelo.vagaCriada"
            defaultMessage="Sua vaga-modelo foi criada!"
          />
        </h1>
        <p className={descriptionStyle}>
          <FormattedMessage
            id="vagaModelo.usarVaga"
            defaultMessage="Para usá-la, acesse a publicação de vaga."
          />
        </p>
      </div>

      <Space />

      <FeedbackCard
        icon={<IlustracaoPrancheta />}
        title={
          <FormattedMessage
            id="vagaModelo.title"
            defaultMessage="Vaga-modelo"
          />
        }
        description={
          <FormattedMessage
            id="vagaModelo.description"
            defaultMessage="Crie modelos e ganhe tempo!"
          />
        }
        actions={
          <a
            href={`${process.env.GLOBAL_URL}/vagas/processos-seletivos/nova-vaga-modelo`}
            className={vagasLinkStyle}
          >
            <FormattedMessage
              id="vagaModelo.CriarNovaVaga"
              defaultMessage="Criar nova vaga-modelo"
            />
          </a>
        }
      ></FeedbackCard>

      <Space />
      <div className={linkWrapperStyle}>
        <Text as="p">
          <a href={`${process.env.GLOBAL_URL}`} className={inlineLinkStye}>
            <FormattedMessage
              id="vagaModelo.irParaInicio"
              defaultMessage="Ir para o início"
            />
          </a>
        </Text>
      </div>
    </div>
  );
}
